module.exports = __webpack_public_path__ + "img/reward.f6b940fe.svg";